'use client';

import { FC } from 'react';

import { Heading, Link, Paragraph } from '@purpur/library';
import { Icon } from '@purpur/library/icon';
import { chevronRight } from '@purpur/library/icon/assets/chevron-right';

import { useInitializeTranslations } from '@telialt/common-cms/src/useTranslations';
import HtmlContent from '@telialt/common-html-content/src';

import { NotFoundLinksList, NotFoundPageWrapper } from './NotFound.styles';

export const NotFound: FC = () => {
    const { t } = useInitializeTranslations();

    if (!t) {
        return null;
    }

    return (
        <NotFoundPageWrapper>
            <Heading tag="h1" variant="title-300">
                {t['eshop.not-found.title']}
            </Heading>
            <Paragraph variant="paragraph-100">
                <HtmlContent baseComponent="span" content={t['eshop.not-found.message']} />
            </Paragraph>
            <NotFoundLinksList>
                <li>
                    <Icon svg={chevronRight} size="sm" />
                    <Link href={t['eshop.not-found.links.homepage.url']} variant="navigation" disableVisited={true}>
                        {t['eshop.not-found.links.homepage.label']}
                    </Link>
                </li>
                <li>
                    <Icon svg={chevronRight} size="sm" />
                    <Link href={t['eshop.not-found.links.promotions.url']} variant="navigation" disableVisited={true}>
                        {t['eshop.not-found.links.promotions.label']}
                    </Link>
                </li>
                <li>
                    <Icon svg={chevronRight} size="sm" />
                    <Link href={t['eshop.not-found.links.products.url']} variant="navigation" disableVisited={true}>
                        {t['eshop.not-found.links.products.label']}
                    </Link>
                </li>
                <li>
                    <Icon svg={chevronRight} size="sm" />
                    <Link href={t['eshop.not-found.links.help.url']} variant="navigation" disableVisited={true}>
                        {t['eshop.not-found.links.help.label']}
                    </Link>
                </li>
            </NotFoundLinksList>
        </NotFoundPageWrapper>
    );
};
